














import { Component, Vue } from 'vue-property-decorator';
import Popup from '@/components/popups/Popup.vue';
import { namespace } from 'vuex-class';
import { formatTimeHMS } from '@/utils/date-helpers';

const puzzle = namespace('Puzzle');

const ui = namespace('UI');

@Component({
  components: {
    Popup,
  },
})
export default class RevealPuzzlePopup extends Vue {
  @puzzle.State
  private userAnswers!: Record<string, string[]>;

  @puzzle.State
  private puzzleTime!: number;

  @puzzle.State
  private hintsUsed!: number;

  @ui.Action
  private openCalendarPopup!: () => void;

  get hintsAmount() {
    return this.hintsUsed.toString();
  }

  get wordsAmount() {
    return Object.keys(this.userAnswers).length;
  }

  get formattedTime() {
    return formatTimeHMS(this.puzzleTime);
  }

  private allWords: string = (window as any).languages['AllWords'];
  private timeWithHints: string = (window as any).languages['TimeWithHints'];
  private morePuzzles: string = (window as any).languages['MorePuzzles'];
}
